import { ReactElement } from 'react';
import { BlocksButton } from '@blocks-web-components/components/button/button';
import cx from 'classnames';
import styles from './EquipmentActionCard.module.scss';

export interface EquipmentActionCardProps {
  classname?: string;
  children: ReactElement | ReactElement[] | string;
  buttonProps?: BlocksButton;
  onClick: () => void;
  isAssetLandingFeatureFlag: boolean;
}

export const EquipmentActionCard = ({
  classname,
  children,
  onClick,
  isAssetLandingFeatureFlag,
  ...buttonProps
}: EquipmentActionCardProps) => {
  return (
    <button
      className={cx(styles['action-card'], classname)}
      {...buttonProps}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default EquipmentActionCard;
